/**
 * Costanti del sito - configurazione centralizzata
 */

// URL e dominio
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://geekscreations.com';
export const SITE_NAME = 'GeeksCreations';

// Dati aziendali
export const COMPANY = {
  name: 'GeeksCreations',
  legalName: 'GEEKSCREATIONS SRL',
  email: 'hello@geekscreations.com',
  vatNumber: '14201870962',
  pec: 'geekscreations@postecertifica.it',
  legalAddress: 'Via Eleonora Pimentel Fonseca 18 – 20127 Milano (MI)',
  shareCapital: '€ 10.000,00',
  rea: '2765877',
} as const;

// Social media
export const SOCIAL_LINKS = {
  linkedin: 'https://linkedin.com/company/geekscreations', // Modifica con il link reale
  github: 'https://github.com/geekscreations', // Modifica con il link reale
  twitter: 'https://twitter.com/geekscreations', // Modifica con il link reale
  instagram: 'https://instagram.com/geekscreations', // Modifica con il link reale
} as const;

// Microsoft Clarity
export const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID || 'ughb7mn85t';

// CookieYes
export const COOKIEYES_ID = process.env.NEXT_PUBLIC_COOKIEYES_ID || '9198eb946dac607d66f4d216';

// SEO defaults
export const SEO_DEFAULTS = {
  title: 'GeeksCreations',
  description: 'La linea è il prompt d\'attesa, il punto è l\'input che genera qualcosa di nuovo. Nasciamo dalla passione per il codice e per il design.',
  keywords: ['geekscreations', 'sviluppo software', 'web development', 'design', 'consulenza IT'] as string[],
  author: 'GeeksCreations',
  ogImage: `${SITE_URL}/og-image.jpg`, // Crea un'immagine Open Graph
} as const;

// Footer
export const FOOTER = {
  copyright: `© ${new Date().getFullYear()} ${COMPANY.name}. Tutti i diritti riservati.`,
  links: {
    privacy: '/privacy',
    terms: '/termini',
    cookie: '/cookie',
  },
} as const;

// Contact CTA
export const CONTACT_CTA = {
  email: {
    href: `mailto:${COMPANY.email}?subject=Richiesta%20dal%20sito%20GeeksCreations`,
  },
  call: {
    href: 'https://cal.com/jessica-corrias-geekscreations/geekscreations-contact-form',
  },
} as const;

